module.exports = __webpack_public_path__ + "static/media/method-3b.7a6d2a0d.png";